/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



// SicilyAddict smart cart upsell: Ajax add + native drawer refresh.
document.addEventListener('click', async function (event) {
  const button = event.target.closest('[data-smart-upsell-add]');
  if (!button) return;
  event.preventDefault();
  if (button.disabled) return;
  const variantId = Number(button.dataset.variantId);
  if (!variantId) return;
  const originalText = button.textContent;
  button.disabled = true;
  button.textContent = button.dataset.addingLabel || 'Wird hinzugefügt...';
  try {
    const response = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({items: [{id: variantId, quantity: 1}]})
    });
    if (!response.ok) throw new Error('Cart add failed');
    document.documentElement.dispatchEvent(new CustomEvent('product:added', {bubbles: true, detail: {quantity: 1}}));
  } catch (error) {
    console.error(error);
    button.disabled = false;
    button.textContent = originalText;
    alert('Das Produkt konnte nicht hinzugefügt werden. Bitte versuche es erneut.');
  }
});

// SicilyAddict: interruttore offerta dessert nel carrello a scomparsa (snippets/smart-cart-dessert.liquid).
// OFF -> ON: aggiunge 1 pezzo (cart/add.js) e lancia product:added, come gli upsell.
// ON -> OFF: toglie la riga (cart/change.js, key + quantita' 0) e lancia cart:refresh,
// l'evento con cui il tema ridisegna il carrello a scomparsa.
document.addEventListener('click', async function (event) {
  const toggle = event.target.closest('[data-sa-dessert-toggle]');
  if (!toggle) return;
  event.preventDefault();
  if (toggle.getAttribute('aria-busy') === 'true') return;

  const wasOn = toggle.getAttribute('aria-checked') === 'true';
  const root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  toggle.setAttribute('aria-checked', wasOn ? 'false' : 'true');
  toggle.setAttribute('aria-busy', 'true');
  const busyTimer = setTimeout(function () { toggle.removeAttribute('aria-busy'); }, 6000);

  try {
    let response;
    if (wasOn) {
      const lineKey = toggle.dataset.lineKey;
      if (!lineKey) throw new Error('Missing line key');
      response = await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({id: lineKey, quantity: 0})
      });
    } else {
      const variantId = Number(toggle.dataset.variantId);
      if (!variantId) throw new Error('Missing variant id');
      response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: [{id: variantId, quantity: 1}]})
      });
    }
    if (!response.ok) throw new Error('Dessert toggle failed');

    if (wasOn) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true, detail: {scrollToTop: false}}));
    } else {
      document.documentElement.dispatchEvent(new CustomEvent('product:added', {bubbles: true, detail: {quantity: 1}}));
    }
  } catch (error) {
    console.error(error);
    clearTimeout(busyTimer);
    toggle.setAttribute('aria-checked', wasOn ? 'true' : 'false');
    toggle.removeAttribute('aria-busy');
    alert('Das hat leider nicht geklappt. Bitte versuche es erneut.');
  }
});

/*
 * NOTA (08-09-2026):
 * Qui c'era una patch JS che a runtime riscriveva "VEDI TUTTI" -> "Alle ansehen",
 * la soglia "Kostenloser Versand ab 99 €" e i link /collections/arancini-siciliani
 * e /collections/dolci-in-vasetto.
 * La patch e' stata RIMOSSA perche' le cause reali sono state corrette alla fonte
 * in templates/index.json (impostazioni delle sezioni, modificabili dall'editor del tema).
 * Non reintrodurre workaround DOM: correggere sempre l'impostazione della sezione.
 */
